import React from 'react';
import { IS_IN_APP_WEBVIEW_BROWSER } from 'constants/default-config';
import { useThemeWithPartner } from 'components/common/ThemeConfigProvider';
import { browserName, isMobile } from 'react-device-detect';

export default function WorkplazeThemeHideElement({ children }) {
    const theme = useThemeWithPartner();

    if (theme.name === 'workplaze' && isMobile && IS_IN_APP_WEBVIEW_BROWSER.some((e) => e === browserName)) return null;

    return children;
}
